import PropTypes from 'prop-types';

export const treeSelectionNodeShape = PropTypes.shape({
  /**
   * Node id
   */
  id: PropTypes.string.isRequired,
  /**
   * name to display for the current node, if doesn't exist then headerElement or itemRenderer must appear.
   */
  name: PropTypes.node,
  /**
   * Node SVG icon ID
   */
  svgId: PropTypes.string,
  /**
   * SVG node
   */
  svg: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  /**
   * Optional element to render inside the node, before the label
   */
  headerElement: PropTypes.node,
  /**
   * Node type
   */
  type: PropTypes.string,
  /**
   * Is fetched. Set to false when need to fetch when opened.
   */
  fetched: PropTypes.bool,
  /**
   * Whether or not the node is toggled. Set to true to open it's children.
   */
  toggled: PropTypes.bool,
  /**
   * Array of node children
   */
  children: PropTypes.array,
  /**
   * Whether the current node has more children,
   * can be either boolean (pre calculated)
   * or a function ({ parentNodes, availableChildNodes }) => boolean
   */
  hasMoreChildren: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  /**
   * Optional side items array
   */
  sideItems: PropTypes.arrayOf(PropTypes.node),
  /**
   * Render the arrow on the right side of the label.
   */
  rightArrow: PropTypes.bool,
  /**
   * A function called when the mouse enters the node's container area.
   */
  onMouseEnter: PropTypes.func,
  /**
   * A function called when the mouse leaves the node's container area.
   */
  onMouseLeave: PropTypes.func,
  /**
   * Optional Item Renderer, Wraps the default item container.
   */
  itemRenderer: PropTypes.func
});
